export default "__VITE_ASSET__e497390f__"